import React, { useState, useEffect } from "react";
import { API, graphqlOperation } from "aws-amplify";
import { timeslotByEventTypeByDateByTime } from "../../../graphql/queries";
import { Button, Confirm } from "react-admin";
import { makeStyles } from "@material-ui/core/styles";
import { alpha } from "@material-ui/core/styles/colorManipulator";
import classnames from "classnames";
import { DeleteIcon } from "../../../components/common/iconography";
import { deleteEventType, updateEventType } from "../../../graphql/mutations";
import { logError } from "../../../utils/appUtils";
import { deepRedirect } from "../../../utils/utils";

const useStyles = makeStyles(
  (theme) => ({
    deleteButton: {
      color: theme.palette.error.main,
      "&:hover": {
        backgroundColor: alpha(theme.palette.error.main, 0.12),
        "@media (hover: none)": {
          backgroundColor: "transparent",
        },
      },
    },
  }),
  { name: "RaDeleteWithConfirmButton" },
);

const getTimeSlotsForEvent = async (
  record,
  setHasEvents,
  setHasFutureEvents,
) => {
  if (!record?.id) {
    return;
  }

  const today = new Date();

  debugger;
  const futurePromise = API.graphql(
    graphqlOperation(timeslotByEventTypeByDateByTime, {
      eventTypeId: record.id,
      yearMonthDayTime: {
        gt: {
          year: today.getFullYear(),
          month: today.getMonth(),
          day: today.getDate(),
        },
      },
      limit: 1,
    }),
  );

  const allTimePromise = API.graphql(
    graphqlOperation(timeslotByEventTypeByDateByTime, {
      eventTypeId: record.id,
      limit: 1,
    }),
  );

  // Use Promise.all to wait for both promises to resolve
  const [futureResponse, allTimeResponse] = await Promise.all([
    futurePromise,
    allTimePromise,
  ]);

  const hasFutureEvents =
    futureResponse.data.timeslotByEventTypeByDateByTime.items.length > 0;

  const hasEvents =
    allTimeResponse.data.timeslotByEventTypeByDateByTime.items.length > 0;

  setHasFutureEvents(hasFutureEvents);
  setHasEvents(hasEvents);
};

export const DeleteEventTypeButton = ({
  record,
  backPath,
  history,
  notify,
  isDisabled,
  className,
}) => {
  const [hasEvents, setHasEvents] = useState(true);
  const [hasFutureEvents, setHasFutureEvents] = useState(true);
  const [isDeleting, setIsDeleting] = useState(false);
  const [open, setOpen] = useState(false);
  const classes = useStyles();

  useEffect(() => {
    if (!record?.id) {
      return;
    }
    getTimeSlotsForEvent(record, setHasEvents, setHasFutureEvents);
  }, [record?.id]);

  const handleDialogOpen = () => setOpen(true);
  const handleDialogClose = () => setOpen(false);

  const getConfirmContent = () => {
    if (hasFutureEvents)
      return "There are future timeslots scheduled for this event Type. Are you sure you want to delete this event type, scheduled events will not be deleted?";
    return "Are you sure you want to delete this event type?";
  };

  const handleDelete = async (event) => {
    setIsDeleting(true);

    debugger;

    try {
      if (record.assetTypeId) {
        notify("Clear Asset before deleting.", "warning");
      } else {
        if (!hasEvents) {
          await API.graphql(
            graphqlOperation(deleteEventType, { input: { id: record.id } }),
          );
        } else {
          const eventTypeToUpdate = {
            ...record,
            active: "false",
          };
          delete eventTypeToUpdate.assetType;
          delete eventTypeToUpdate.createdAt;
          delete eventTypeToUpdate.updatedAt;

          await API.graphql(
            graphqlOperation(updateEventType, {
              input: eventTypeToUpdate,
            }),
          );
        }

        notify("Event type deleted successfully", "success");
        const tab = history.location.state.tab;
        deepRedirect(history, backPath, null, { tab });
      }
    } catch (err) {
      logError(
        "eventTypes:DeleteEventTypeButton:handleDelete:" +
          JSON.stringify(record),
        err,
        notify,
      );
    } finally {
      setIsDeleting(false);
      setOpen(false);
    }
  };

  return (
    <React.Fragment>
      <Button
        label="Delete"
        disabled={!record || isDeleting || isDisabled}
        onClick={handleDialogOpen}
        className={classnames(
          "ra-delete-button",
          classes.deleteButton,
          className,
        )}
      >
        <DeleteIcon />
      </Button>
      <Confirm
        isOpen={open}
        title="Delete Event Type"
        content={getConfirmContent()}
        onConfirm={handleDelete}
        onClose={handleDialogClose}
      />
    </React.Fragment>
  );
};
